export { default } from './AlertIcon';
